import { useMemo } from "react";
import { ScrollView } from "react-native-gesture-handler";
import PublicAssetTag from "src/api/graphql/__generated__/enums/PublicAssetTag";
import InteractivePillButton from "src/components/InteractivePillButton";
import useEditCoverGalleryPadding from "src/screens/(internal)/EditCoverGalleryModal/hooks/useEditCoverGalleryPadding";
import { paddingMedium } from "src/styles/spacing";
import getTagDisplayText from "./helpers/getTagDisplayText";

interface TagData {
	isSelected: boolean;
	tag: PublicAssetTag;
	text: string;
}

const EditCoverTagSelection = ({
	assetTags,
	selectedTag,
	onTagPress,
}: {
	assetTags: PublicAssetTag[];
	selectedTag: PublicAssetTag | undefined;
	onTagPress?: (tag: PublicAssetTag) => void;
}) => {
	const tagData = useMemo<TagData[]>(() => {
		const tagData: TagData[] = [];
		for (const tag of assetTags) {
			const title = getTagDisplayText(tag);
			if (title) {
				tagData.push({
					isSelected: tag === selectedTag,
					tag,
					text: title,
				});
			}
		}
		return tagData;
	}, [assetTags, selectedTag]);
	const { paddingHorizontal } = useEditCoverGalleryPadding();

	return (
		<ScrollView
			horizontal
			showsHorizontalScrollIndicator={false}
			style={{
				flexGrow: 0,
			}}
			contentContainerStyle={{
				alignItems: "center",
				paddingHorizontal,
				columnGap: paddingMedium,
				paddingTop: paddingMedium,
				paddingBottom: paddingMedium,
			}}
		>
			{tagData.map(({ tag, isSelected, text }) => (
				<InteractivePillButton
					key={`${tag}-${isSelected}`}
					isSelected={isSelected}
					onPress={() => onTagPress?.(tag)}
				>
					{text}
				</InteractivePillButton>
			))}
		</ScrollView>
	);
};
export default EditCoverTagSelection;
